import React from "react";
import { FaCode, FaPaintBrush, FaChartLine } from "react-icons/fa";
import { motion } from "framer-motion";

function Services(){
return(

<section className="py-20 bg-gray-100 text-center text-black dark:text-white" id="services"  >

<h2 className="text-4xl font-bold mb-12">My Services</h2>

<div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-8">

<motion.div 
initial={{opacity:0, y:50}} 
whileInView={{opacity:1, y:0}} 
transition={{duration:0.5}}
className="bg-white p-8 rounded-xl shadow-lg hover:scale-105 transition"
>
<FaCode className="text-4xl text-blue-500 mb-4 mx-auto"/>
<h3 className="text-xl font-semibold mb-2">Web Development</h3>
<p>I build modern responsive websites using React.</p>
</motion.div>

<motion.div 
initial={{opacity:0, y:50}} 
whileInView={{opacity:1, y:0}} 
transition={{duration:0.5, delay:0.2}}
className="bg-white p-8 rounded-xl shadow-lg hover:scale-105 transition"
>
<FaPaintBrush className="text-4xl text-blue-500 mb-4 mx-auto"/>
<h3 className="text-xl font-semibold mb-2">UI/UX Design</h3>
<p>Clean and modern user interface designs.</p>
</motion.div>

<motion.div 
initial={{opacity:0, y:50}} 
whileInView={{opacity:1, y:0}} 
transition={{duration:0.5, delay:0.4}}
className="bg-white p-8 rounded-xl shadow-lg hover:scale-105 transition"
>
<FaChartLine className="text-4xl text-blue-500 mb-4 mx-auto"/>
<h3 className="text-xl font-semibold mb-2">SEO Optimization</h3>
<p>Improve your website ranking and traffic.</p>
</motion.div>

</div>

</section>

);
}

export default Services;